import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { hdDailyPlayerDetails } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { productList } from "@/api/management/productMapping";
import { gmTool, serchSelect, tabulation } from "@/mixins/index";
import historyList from "./components/historyList";
export default {
  name: "playerDailyDetailSnapshot",
  mixins: [gmTool, serchSelect, tabulation],
  components: {
    historyList: historyList
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      dayList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      paramsData: {
        special_product_id: [],
        role_id: "",
        open_server_day: "",
        page: 1,
        server_id: [],
        server_ids: [],
        is_prod: ""
      },
      open_server_days: '',
      date: [],
      total: 0,
      serverList: []
    };
  },
  created: function created() {
    this.paramsData.is_prod = "";
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    serverListChange: function serverListChange(e) {
      console.log("eeee", e);
    },
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.page = e;
                _this.reqLoading = true;
                _this.paramsData.server_id = []; //服务器数据处理

                if (_this.paramsData.server_ids && _this.paramsData.server_ids.length != 0) {
                  _this.paramsData.servers = _this.paramsData.server_ids.map(function (item) {
                    _this.paramsData.server_id.push(item.split("+")[0]);

                    return {
                      openTimeTimestamp: item.split("+")[1],
                      id: item.split("+")[0]
                    };
                  });
                } else {
                  _this.paramsData.servers = [];
                  _this.paramsData.server_id = [];
                  _this.paramsData.open_server_day = [];
                }

                params = JSON.parse(JSON.stringify(_this.paramsData));
                params.open_server_day = params.open_server_day && params.open_server_day.join(",");

                if (_this.open_server_days) {
                  params.open_server_day = _this.open_server_days;
                }

                if (params.server_id.length) {
                  params.server_id = params.server_id.join(",");
                }

                if (_this.searchData.special_product_id.length) {
                  params.special_product_id = _this.searchData.special_product_id.join(",");
                }

                delete params.server_ids;
                hdDailyPlayerDetails(_objectSpread(_objectSpread({}, params), {}, {
                  game_id: _this.rawData.game_id
                })).then(function (res) {
                  if (res.status == 200) {
                    _this.currentPage = 1;
                    _this.tableCopyTableList = JSON.parse(JSON.stringify(res.data));
                    _this.tableData = _this.currentChangePage(_this.pageSize, _this.currentPage); // this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getServer: function getServer() {
      var _this2 = this;

      // this.paramsData.serverID = ''
      this.paramsData.server_ids = [];
      this.paramsData.open_server_day = [];
      serverList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page_size: ''
      })).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    goToHistory: function goToHistory(row) {
      var params = {
        server_day: row.server_day,
        role_id: row.role_id,
        server_id: row.server_id,
        game_id: this.rawData.game_id,
        is_prod: this.paramsData.is_prod
      };
      this.$refs.historyList.init(params);
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var list, columns;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                list = _this3.tableCopyTableList;
                columns = [{
                  label: _this3.$t('server'),
                  prop: 'server_id'
                }, {
                  label: _this3.$t('openServerDay'),
                  prop: 'server_day'
                }, {
                  label: _this3.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this3.$t('roleName'),
                  prop: 'role_name'
                }, {
                  label: _this3.$t('dailyPlayDuration'),
                  prop: 'duration'
                }, {
                  label: _this3.$t('roleLevel'),
                  prop: 'level'
                }, {
                  label: _this3.$t('roleFightPower'),
                  prop: 'fighting'
                }, {
                  label: _this3.$t('mainLevel'),
                  prop: 'main_line_task'
                }, {
                  label: _this3.$t('climbTower'),
                  prop: 'pata'
                }, {
                  label: _this3.$t('totalRecharge'),
                  prop: 'total_amount'
                }, {
                  label: _this3.$t('registerTime'),
                  prop: 'register_time'
                }, {
                  label: _this3.$t('mainLineTaskCostTime'),
                  prop: 'main_line_cost_time'
                }, {
                  label: _this3.$t('climbTowerCostTime'),
                  prop: 'pata_cost_time'
                }, {
                  label: _this3.$t('lastLoginTime'),
                  prop: 'last_login_time'
                }, {
                  label: _this3.$t('lastRechargeTime'),
                  prop: 'recharge_time'
                }];

                _this3.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this3.$route.meta.title
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};